/**
 * WordPress dependencies
 */
import { useState, useEffect, useContext } from "@wordpress/element";
import { __ } from "@wordpress/i18n";
import { Button } from "@wordpress/components";

import PatternContext from '../Context/PatternContext';

const PatternlySidebar = () => {

    const patternContext = useContext(PatternContext);

    const [error, setError] = useState(false);
    const [isVisible, setIsVisible] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const getDefaultData = (event) => {
        
        //active item.
        activeItem(event);

        patternContext.setQueryType('all');
        patternContext.setQueryTypeValue(false);
        patternContext.setCurrentPage(1);
        patternContext.setLoadPatternData(true);
        patternContext.setLoadMoreButton(true);
    }

    const activeItem = (event) => {
        //remove active class.
        let activeCategoryItem = document.querySelector('.pat-sidebar-active');
        activeCategoryItem.classList.remove('pat-sidebar-active');

        //add active class.
        event.currentTarget.classList.add('pat-sidebar-active');

        //remove menu active class.
        let activeMenuItem = document.querySelector('.pat-main-li-active');
        activeMenuItem.classList.remove('pat-main-li-active');

        //active first child.
        let firstMenuItem = document.querySelector('.pat-main-ul li:first-child');
        firstMenuItem.classList.add('pat-main-li-active');
    }

    const getCatPatterns = (event) => {

        //active item.
        activeItem(event);

        let category = event.currentTarget.getAttribute('category');
        patternContext.setQueryType('category');
        patternContext.setQueryTypeValue(category);
        patternContext.setCurrentPage(1);
        patternContext.setLoadPatternData(true);
        patternContext.setLoadMoreButton(true);
    };

    function renderCatItem() {
        if(Object.keys(patternContext.categoryData).length > 0 && patternContext.letsPrintCatData) {
            return(
                <ul className="pat-sidebar-ul">
                    <li class="pat-sidebar-li pat-sidebar-active" onClick={getDefaultData}>
                            <span class="text">{__('All', 'patternly')}</span> 
                            <span class="text">{patternContext.categoryData['types'][0]['count'] + patternContext.categoryData['types'][1]['count']}</span>
                    </li>
                    {
                        patternContext.categoryData['categories'].map(category => {
                            return(
                                <li 
                                class="pat-sidebar-li" 
                                key={category.slug} 
                                category={category.slug}
                                onClick={getCatPatterns}
                                >
                                        <span class="text">{category.name}</span> 
                                        <span class="text">{category.count}</span>
                                </li>
                            )
                        })
                    }
                </ul>
                
            )
        }
    }

    return (
        <>
            <div class="pat-sidebar">
                <h4 class="pat-sidebar-menu-header">{__("Categories", "patternly")}</h4>
                {renderCatItem()}
                
                <ul class="pat-skeleton-sidebar-ul">
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                    <li class="pat-skeleton-saidbar-li"></li>
                </ul>
            </div>
        </>
    );
};

export default PatternlySidebar;